import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ContactService } from '../../shared/services/contact.service';
import { CommonModule } from '@angular/common';
import { CaptchaComponent } from '../../components/captcha/captcha.component';
import { RecaptchaDebugService } from '../../services/recaptcha-debug.service';

@Component({
  selector: 'app-contact',
  imports: [HeaderComponent, FooterComponent, FormsModule, TranslateModule, CommonModule, CaptchaComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent implements OnInit {
  isSubmitting = false;
  submitSuccess = false;
  submitError = false;
  captchaToken: string = '';
  captchaError: boolean = false;

  constructor(
    private authService: AuthService, 
    private router: Router,
    private contactService: ContactService,
    private recaptchaDebug: RecaptchaDebugService
  ) {}

  ngOnInit() {
    // Debug reCAPTCHA configuration
    this.recaptchaDebug.validateConfiguration();
  }
  
  formData = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  };

  onSubmit() {
    if (this.isSubmitting) return;

    // Basic validation
    if (!this.formData.name || !this.formData.email || !this.formData.subject || !this.formData.message) {
      alert('Please fill in all required fields.');
      return;
    }

    // CAPTCHA validation
    if (!this.captchaToken) {
      this.captchaError = true;
      alert('Please complete the CAPTCHA verification.');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.formData.email)) {
      alert('Please enter a valid email address.');
      return;
    }

    this.isSubmitting = true;
    this.submitSuccess = false;
    this.submitError = false;

    try {
      console.log('Opening email client to send to alosailimu@waseel.com:', this.formData);
      
      // Open email client directly
      this.contactService.sendContactForm(this.formData);
      
      this.submitSuccess = true;
      this.resetForm();
      
      // Show success message for 5 seconds
      setTimeout(() => {
        this.submitSuccess = false;
      }, 5000);
      
    } catch (error) {
      console.error('Error opening email client:', error);
      this.submitError = true;
      
      // Show error message for 5 seconds
      setTimeout(() => {
        this.submitError = false;
      }, 5000);
    } finally {
      this.isSubmitting = false;
    }
  }

  private resetForm() {
    this.formData = {
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    };
    this.captchaToken = '';
    this.captchaError = false;
  }

  onCaptchaResolved(token: string) {
    this.captchaToken = token;
    this.captchaError = false;
  }

  onCaptchaError() {
    this.captchaToken = '';
    this.captchaError = true;
  }

  openKeyClockLogin(): void {
    this.authService.login();
  }
}
